import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { NavController } from "@ionic/angular";

import { DatesHelpers } from "src/app/helpers/date";
@Component({
  selector: "app-calendrier",
  templateUrl: "./calendrier.component.html",
  styleUrls: ["./calendrier.component.scss"],
  standalone: false,
})
export class CalendrierComponent implements OnInit, OnChanges {
  showCalend: boolean = true;
  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth();
  months = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];
  monthYear = `${this.months[this.currentMonth]} ${this.currentYear}`;

  daysOfWeek = ["D", "L", "M", "M", "J", "V", "S"];

  weeks: any[] = [];
  _selectedDate = "";
  textDate = "";
  @Output() selectedDate = new EventEmitter<string>();
  @Input() reservedDates?: any[];
  reserved: { month: number; year: number; day: number }[] = [];
  constructor(
    private navController: NavController,
    private datesHelpers: DatesHelpers
  ) {}

  ngOnInit() {
    this.renderCalendar(this.currentYear, this.currentMonth);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["reservedDates"] && !changes["reservedDates"].firstChange) {
      this.displayReservedDates();
    }
  }
  displayReservedDates() {
    if (this.reservedDates) {
      let set = new Set(this.reservedDates);
      let array = [...set];
      let array2 = array.map((data: any) => {
        let date = data.a;
        let dataArray = date.split(" ");
        let year = dataArray[0].split("-")[0];
        let month = dataArray[0].split("-")[1];
        let day = dataArray[0].split("-")[2];
        return {
          month: Number(month),
          year: Number(year),
          day: Number(day),
        };
      });
      this.reserved = array2;
      this.renderCalendar(this.currentYear, this.currentMonth);
    }
  }
  handleShowCalend() {
    this.showCalend = !this.showCalend;
  }

  goBack() {
    this.navController.pop();
  }

  nextMonth() {
    this.currentMonth++;
    if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    }

    this.monthYear = `${this.months[this.currentMonth]} ${this.currentYear}`;

    this.renderCalendar(this.currentYear, this.currentMonth);
  }
  getdayColor(day: any, year: any, month: any): string {
    let color = "";
    if (
      day === new Date().getDate() &&
      year === this.currentYear &&
      month === this.currentMonth
    ) {
      color = "blue";
    } else {
      let comparable = {
        month: month,
        day: day,
        year: year,
      };
      let isReserved = this.reserved.filter((date: any) => {
        return date.day == comparable.day;
      });
      isReserved.length && (color = "green");
    }
    return color;
  }
  renderCalendar(year: number, month: number) {
    const firstDayOfMonth = new Date(year, month, 1);
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const dayOfWeek = firstDayOfMonth.getDay();

    this.weeks = [];
    let week: any[] = [];

    for (let i = 0; i < dayOfWeek; i++) {
      week.push({ number: "", color: "" });
    }

    for (let day = 1; day <= daysInMonth; day++) {
      let monthNumberFormat =
        (month + 1).toString().length >= 2 ? month + 1 : `0${month + 1}`;
      week.push({
        number: day,
        color: this.getdayColor(day, year, month),
        selected:
          day === new Date().getDate() &&
          year === this.currentYear &&
          month === this.currentMonth
            ? true
            : false,
        date: `${day}/${monthNumberFormat}/${year}`,
      });
      if (
        day === new Date().getDate() &&
        year === this.currentYear &&
        month === this.currentMonth
      ) {
        let date = `${day}/${monthNumberFormat}/${year}`;
        let textDate = this.datesHelpers.formatDateToTextual(date);
        this.selectedDate.emit(date);
        this.textDate = textDate;
      }
      if (new Date(year, month, day).getDay() === 6 || day === daysInMonth) {
        this.weeks.push(week);
        week = [];
      }
    }
  }

  handleSelectDateDay(selectedDay: any) {
    let textDate = this.datesHelpers.formatDateToTextual(selectedDay.date);
    this.textDate = textDate;
    this._selectedDate = selectedDay.date;
    this.selectedDate.emit(selectedDay.date);
    
    let isReserved = this.reserved.filter((date: any) => {
      return date.day == selectedDay.day;
    });
    this.weeks.map((week: any) => {
      week.map((day: any) => {
        day.color = day === selectedDay ? "blue" :( day.color === "green") ? "green": "";
        day.selected = day === selectedDay ? true : false;
      });
    });
  }
  onDateClick(day: any) {
    if(!this.isPast(day.date)){
      if (day.color === "blue") {
      } 
      else {
        this.handleSelectDateDay(day);
      }
    }    
  }
  formatMonthYear(date: Date): string {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[date.getMonth()] + " " + date.getFullYear();
  }

  goToNextMonth() {
    if (this.currentMonth === 11) {
      this.currentYear++;
      this.currentMonth = 0;
    } else {
      this.currentMonth++;
    }
    this.renderCalendar(this.currentYear, this.currentMonth);
    this.monthYear = this.formatMonthYear(
      new Date(this.currentYear, this.currentMonth)
    );
  }
  goToPrevMonth() {
    if (this.currentMonth === 0) {
      this.currentYear--;
      this.currentMonth = 11;
    } else {
      this.currentMonth--;
    }
    this.renderCalendar(this.currentYear, this.currentMonth);
    this.monthYear = this.formatMonthYear(
      new Date(this.currentYear, this.currentMonth)
    );
  }
  isPast(date: string){
    if(date){
      let year = date.split("/")[2];
      let month = date.split("/")[1];
      let day = date.split("/")[0];
      let currentDate = new Date().setHours(0, 0, 0, 0);
      let formattedDate = year+'-'+month+'-'+day;
      const testDate = new Date(formattedDate).setHours(0, 0, 0, 0);
      return currentDate > testDate;
    }
    else{
      return false;
    }
       
  }
}
